import React, { useContext, useState } from "react";

export default function PackageSearchResultFlightDetails({ result, onClose }) {
    return (
        <div className="fixed inset-0 z-50 overflow-y-auto">
            <div className="transition flex items-center justify-center min-h-screen pt-14 px-4 pb-20 text-center sm:block sm:p-0">
                <div
                    className="fixed inset-0 bg-gray-500/75 bg-opacity-75"
                    onClick={() => onClose()}
                ></div>

                <div className="inline-block transform translate-0 transition-all align-bottom bg-white rounded-2xl pt-6 text-left overflow-hidden shadow-xl sm:my-8 sm:align-middle sm:max-w-[850px] sm:w-full">
                    <div className="absolute top-2 right-2">
                        <button
                            onClick={() => onClose()}
                            className="text-gray-400 hover:text-content_3"
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>

                    <div className="p-4">
                        <div className="grid grid-cols-1 md:grid-cols-[1fr_2fr_1fr] gap-6">
                            <div className="hidden md:flex flex-col">
                                <div className="flex-1 flex items-center pl-4">
                                    <div>
                                        <div className="text-xs text-content_3 mb-1">
                                            {result.flightOutbound.airlineName}
                                        </div>
                                    </div>
                                </div>

                                <div className="border-t border-dashed border-gray-300"></div>

                                <div className="flex-1 flex items-center pl-4">
                                    <div className="text-xs text-content_3 mb-2">
                                        {result.flightInbound.airlineName}
                                    </div>
                                </div>
                            </div>

                            <div className="flex flex-col gap-2">
                                <div className="flex-1 flex items-center flex-col gap-2">
                                    <div className="flex w-full flex-1 items-center min-w-0">
                                        <div className="mr-2 md:mr-3 text-content_3 shrink-0">
                                            <svg
                                                width="24"
                                                height="25"
                                                viewBox="0 0 24 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M2.00031 20.75H18.0003M3.82527 12.9161C3.55027 12.7161 3.30027 12.4661 3.00028 11.5911C2.91891 11.3741 2.61139 10.2862 2.35028 9.29109C2.13003 8.4517 1.93377 7.68555 2.02528 7.49109C2.10029 7.29109 2.20027 7.14109 2.52527 6.94109C2.72527 6.81802 3.75027 6.56609 3.95027 6.51609C4.15027 6.46609 4.42526 6.44109 4.65027 6.51609C5.07527 6.59109 5.95027 7.86609 6.17527 8.01609C6.27526 8.11609 6.60027 8.407 6.97527 8.44109C7.25027 8.46609 7.52527 8.39109 7.82528 8.26609C8.10027 8.15151 13.5253 5.51609 14.0253 5.29109C18.1003 3.59109 21.0603 6.38609 21.5103 6.98609C21.9753 7.56609 22.0753 7.74109 21.9503 8.24109C21.7887 8.76609 21.3503 8.86609 21.1003 8.94109C20.8503 9.01609 17.4003 9.94109 16.0503 10.3161C15.7554 10.4121 15.6114 10.6049 15.5753 10.6411C15.4003 10.8911 14.6053 12.5911 14.3803 12.9661C14.2253 13.3661 13.8003 13.8661 13.2503 14.0661C12.6753 14.2661 11.6753 14.4911 11.4503 14.5661C11.2253 14.6411 10.7003 14.7911 10.5253 14.7411C10.3003 14.6911 10.0853 14.4661 10.1853 14.1161C10.2853 13.7661 10.4753 12.7911 10.5003 12.6411C10.5253 12.4911 10.7753 11.8661 10.5003 11.8411C10.4503 11.7661 9.92527 11.9911 9.15027 12.1661C8.57449 12.3282 7.9715 12.4886 7.55027 12.5911C5.92527 13.0661 5.04521 13.1911 4.85027 13.1911C4.47527 13.1911 4.20027 13.1411 3.82527 12.9161Z"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />
                                            </svg>
                                        </div>
                                        <div className="text-center min-w-0 md:w-24 md:shrink-0">
                                            <div className="text-xl font-semibold">
                                                {result.flightOutbound.departureTime}
                                            </div>
                                            <div
                                                className="text-xs text-content_3 w-20 md:w-24 mx-auto text-center leading-tight whitespace-normal break-words"
                                                title={`${result.flightOutbound.departureAirport.name} (${result.flightOutbound.departureAirport.iataCode})`}
                                            >
                                                {result.flightOutbound.departureAirport.name}
                                            </div>
                                        </div>

                                        <div className="flex-1 min-w-0 mx-2 md:mx-3 text-center overflow-hidden">
                                            <div className="text-sm text-content_3">
                                                {result.flightOutbound.duration}
                                            </div>
                                            <div className="border-t border-content_4 my-1 h-[0] relative flex justify-between items-center">
                                                <span className="w-2 h-2 bg-content_4 rounded-full"></span>
                                                <span className="w-2 h-2 bg-content_4 rounded-full"></span>
                                            </div>
                                            <div
                                                className="text-xs text-gray-500 truncate whitespace-nowrap"
                                                title={result.flightOutbound.flightNumber}
                                            >
                                                {result.flightOutbound.flightNumber}
                                            </div>
                                        </div>

                                        <div className="text-center min-w-0 md:w-24 md:shrink-0">
                                            <div className="text-xl font-semibold">
                                                {result.flightOutbound.arrivalTime}
                                            </div>
                                            <div
                                                className="text-xs text-content_3 w-20 md:w-24 mx-auto text-center leading-tight whitespace-normal break-words"
                                                title={`${result.flightOutbound.arrivalAirport.name} (${result.flightOutbound.arrivalAirport.iataCode})`}
                                            >
                                                {result.flightOutbound.arrivalAirport.name}
                                            </div>
                                        </div>

                                        <div className="ml-2 md:ml-3 text-content_3 shrink-0">
                                            <svg
                                                width="25"
                                                height="25"
                                                viewBox="0 0 25 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M6.50146 20.7481H22.5015M4.19749 4.79178C3.57958 4.9603 3.50748 5.66778 3.32748 6.26778C3.17702 6.83204 2.8591 8.08023 2.64285 8.93298C2.48148 9.68778 2.45988 9.98778 2.55588 10.4678C2.78148 11.3678 3.56148 11.7218 5.24148 12.1898C6.08616 12.4058 6.68148 12.587 7.58148 12.827C7.73596 12.8764 8.21601 12.9975 8.60148 13.1018C8.96148 13.2278 9.26148 13.1918 9.19428 13.4678C9.14746 13.5775 8.60388 14.1878 8.09988 14.7278C7.76148 15.1478 7.53348 15.2497 7.53348 15.5678C7.53348 15.5678 7.52148 16.0478 8.19425 16.1078C8.30148 16.1678 9.74148 16.5278 10.2815 16.6838C11.0015 16.8638 11.5415 16.6478 11.9855 16.3478L14.1815 14.9078C14.6615 14.6918 14.7815 14.783 15.3215 14.927L20.1215 16.2278C20.9615 16.5278 21.6815 15.8078 21.4703 14.9678C21.2015 13.4678 20.7215 12.5678 19.9415 11.6078C18.6815 10.1078 17.1453 9.52258 16.0415 9.32778C15.5378 9.23889 13.644 9.08911 11.8415 8.95578C9.99393 8.81912 8.24222 8.69889 8.18148 8.60778C6.86148 8.30778 7.26948 6.36978 6.70548 5.52378C6.48148 5.18778 6.08148 5.12778 5.48148 4.94778C4.97299 4.81761 4.59616 4.68305 4.19749 4.79178Z"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />
                                            </svg>
                                        </div>
                                    </div>

                                    <div className="md:hidden">
                                        <div className="flex items-center gap-2">
                                            <div className="text-xs text-content_3">
                                                {result.flightInbound.airlineName}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="border-t border-dashed border-gray-300"></div>

                                <div className="flex-1 flex flex-col items-center gap-2">
                                    <div className="flex flex-1 w-full items-center min-w-0">
                                        <div className="mr-2 md:mr-3 text-content_3 shrink-0">
                                            <svg
                                                width="24"
                                                height="25"
                                                viewBox="0 0 24 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M2.00031 20.75H18.0003M3.82527 12.9161C3.55027 12.7161 3.30027 12.4661 3.00028 11.5911C2.91891 11.3741 2.61139 10.2862 2.35028 9.29109C2.13003 8.4517 1.93377 7.68555 2.02528 7.49109C2.10029 7.29109 2.20027 7.14109 2.52527 6.94109C2.72527 6.81802 3.75027 6.56609 3.95027 6.51609C4.15027 6.46609 4.42526 6.44109 4.65027 6.51609C5.07527 6.59109 5.95027 7.86609 6.17527 8.01609C6.27526 8.11609 6.60027 8.407 6.97527 8.44109C7.25027 8.46609 7.52527 8.39109 7.82528 8.26609C8.10027 8.15151 13.5253 5.51609 14.0253 5.29109C18.1003 3.59109 21.0603 6.38609 21.5103 6.98609C21.9753 7.56609 22.0753 7.74109 21.9503 8.24109C21.7887 8.76609 21.3503 8.86609 21.1003 8.94109C20.8503 9.01609 17.4003 9.94109 16.0503 10.3161C15.7554 10.4121 15.6114 10.6049 15.5753 10.6411C15.4003 10.8911 14.6053 12.5911 14.3803 12.9661C14.2253 13.3661 13.8003 13.8661 13.2503 14.0661C12.6753 14.2661 11.6753 14.4911 11.4503 14.5661C11.2253 14.6411 10.7003 14.7911 10.5253 14.7411C10.3003 14.6911 10.0853 14.4661 10.1853 14.1161C10.2853 13.7661 10.4753 12.7911 10.5003 12.6411C10.5253 12.4911 10.7753 11.8661 10.5003 11.8411C10.4503 11.7661 9.92527 11.9911 9.15027 12.1661C8.57449 12.3282 7.9715 12.4886 7.55027 12.5911C5.92527 13.0661 5.04521 13.1911 4.85027 13.1911C4.47527 13.1911 4.20027 13.1411 3.82527 12.9161Z"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />
                                            </svg>
                                        </div>
                                        <div className="text-center min-w-0 md:w-24 md:shrink-0">
                                            <div className="text-xl font-semibold">
                                                {result.flightInbound.departureTime}
                                            </div>
                                            <div
                                                className="text-xs text-content_3 w-20 md:w-24 mx-auto text-center leading-tight whitespace-normal break-words"
                                                title={`${result.flightInbound.departureAirport.name} (${result.flightInbound.departureAirport.iataCode})`}
                                            >
                                                {result.flightInbound.departureAirport.name}
                                            </div>
                                        </div>

                                        <div className="flex-1 min-w-0 mx-2 md:mx-3 text-center overflow-hidden">
                                            <div className="text-sm text-content_3">
                                                {result.flightInbound.duration}
                                            </div>
                                            <div className="border-t border-content_4 my-1 h-[0] relative flex justify-between items-center">
                                                <span className="w-2 h-2 bg-content_4 rounded-full"></span>
                                                <span className="w-2 h-2 bg-content_4 rounded-full"></span>
                                            </div>
                                            <div
                                                className="text-xs text-gray-500 truncate whitespace-nowrap"
                                                title={result.flightInbound.flightNumber}
                                            >
                                                {result.flightInbound.flightNumber}
                                            </div>
                                        </div>

                                        <div className="text-center min-w-0 md:w-24 md:shrink-0">
                                            <div className="text-xl font-semibold">
                                                {result.flightInbound.arrivalTime}
                                            </div>
                                            <div
                                                className="text-xs text-content_3 w-20 md:w-24 mx-auto text-center leading-tight whitespace-normal break-words"
                                                title={`${result.flightInbound.arrivalAirport.name} (${result.flightInbound.arrivalAirport.iataCode})`}
                                            >
                                                {result.flightInbound.arrivalAirport.name}
                                            </div>
                                        </div>

                                        <div className="ml-2 md:ml-3 text-content_3 shrink-0">
                                            <svg
                                                width="25"
                                                height="25"
                                                viewBox="0 0 25 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M6.50146 20.7481H22.5015M4.19749 4.79178C3.57958 4.9603 3.50748 5.66778 3.32748 6.26778C3.17702 6.83204 2.8591 8.08023 2.64285 8.93298C2.48148 9.68778 2.45988 9.98778 2.55588 10.4678C2.78148 11.3678 3.56148 11.7218 5.24148 12.1898C6.08616 12.4058 6.68148 12.587 7.58148 12.827C7.73596 12.8764 8.21601 12.9975 8.60148 13.1018C8.96148 13.2278 9.26148 13.1918 9.19428 13.4678C9.14746 13.5775 8.60388 14.1878 8.09988 14.7278C7.76148 15.1478 7.53348 15.2497 7.53348 15.5678C7.53348 15.5678 7.52148 16.0478 8.19425 16.1078C8.30148 16.1678 9.74148 16.5278 10.2815 16.6838C11.0015 16.8638 11.5415 16.6478 11.9855 16.3478L14.1815 14.9078C14.6615 14.6918 14.7815 14.783 15.3215 14.927L20.1215 16.2278C20.9615 16.5278 21.6815 15.8078 21.4703 14.9678C21.2015 13.4678 20.7215 12.5678 19.9415 11.6078C18.6815 10.1078 17.1453 9.52258 16.0415 9.32778C15.5378 9.23889 13.644 9.08911 11.8415 8.95578C9.99393 8.81912 8.24222 8.69889 8.18148 8.60778C6.86148 8.30778 7.26948 6.36978 6.70548 5.52378C6.48148 5.18778 6.08148 5.12778 5.48148 4.94778C4.97299 4.81761 4.59616 4.68305 4.19749 4.79178Z"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                />
                                            </svg>
                                        </div>
                                    </div>

                                    <div className="md:hidden">
                                        <div className="flex items-center gap-2">
                                            <div className="text-xs text-content_3">
                                                {result.flightInbound.airlineName}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <div className="space-y-4 pt-5 md:pt-0">
                                    <div>
                                        <div className="text-xs text-content_3">Baggage</div>
                                        {result.includedBaggage > 0 && (
                                            <div className="text-xs font-medium text-secondary">
                                                {result.includedBaggage}Kg Included
                                            </div>
                                        )}
                                        {result.includedBaggage == 0 && (
                                            <div className="text-xs font-medium text-secondary">
                                                Not Included
                                            </div>
                                        )}
                                    </div>

                                    {result.cabinBag && (
                                        <div>
                                            <div className="text-xs text-content_3">Cabin bag</div>
                                            <div className="text-xs font-medium text-secondary">
                                                {result.cabinBag}
                                            </div>
                                        </div>
                                    )}

                                    {result.handBag && (
                                        <div>
                                            <div className="text-xs text-content_3">Handbag</div>
                                            <div className="text-xs font-medium text-secondary">
                                                Small bag only
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-tertiary rounded-lg px-3 py-2 text-center">
                        <p className="text-xs text-gray-500">
                            Alternative flight times may be available on the next step
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
